module.exports = __webpack_public_path__ + "static/13-44127471a3bb630b9acd8658ecef198f.jpg";